[<template>
  <div>
    <el-table
      :data="allContracts.data"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column label="User" prop="username" sortable></el-table-column>
      <el-table-column label="First Name" prop="first_name" sortable></el-table-column>
      <el-table-column label="Last Name" prop="surname" sortable></el-table-column>
      <el-table-column label="Url" prop="url" sortable></el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
          <template slot-scope="props">
            <el-tooltip content="Download" placement="top" v-if="props.row.url != null">
              <el-button
                type="info"
                circle
                size="small"
                icon="el-icon-document"
                @click="getCidReport(props.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Delete" placement="top" v-if="props.row.url != null">
              <el-button type="danger" circle size="small" icon="el-icon-close" @click="deleteC(props.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="allContracts.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="allContracts.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('contracts', [
      'allContracts',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('contracts', [
      'read',
      'getContract',
      'deleteContract'
    ]),
    ...mapMutations('contracts', [
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read(2)
    },
    currentChange(page) {
      this.setPage(page)
      this.read(2)
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read(2)
    },
    openEdit(blog) {
      this.setDialog(true)
      this.setSelectedBlog(blog)
    },

    getCidReport(contract){
      this.getContract({id:contract.user_id, type:2})
    },

    deleteC(contract){
      this.deleteContract({id:contract.id, type:2})
    }

  },

  mounted() {
    this.read(2)
  }
}
</script>
